// Generated by purs version 0.11.6
"use strict";
module.exports = {};
